import * as React from "react";

const CustomDivider: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1" height="37" viewBox="0 0 1 37" fill="none">
            <path d="M0.5 1V36" stroke="#858585" strokeLinecap="square" />
        </svg>
    );
};

export default React.memo(CustomDivider);
